import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {LocalstorageService} from "../../services/localstorage.service";

export const httpsInterceptor: HttpInterceptorFn = (req, next) => {
    const localstorageService = inject(LocalstorageService);
    const token = localstorageService.getItem('token-growphi');
    
    // Debug: Verificar token
    console.log('🔑 Token encontrado:', !!token);
    console.log('🔑 Token value:', token ? String(token).substring(0, 20) + '...' : 'No token');
    console.log('🌐 URL de la petición:', req.url);
    console.log('🔑 Token completo:', token);
    
    if (token) {
        const clonedReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
        console.log('📤 Enviando petición con token');
        return next(clonedReq);
    }

    console.log('⚠️ Petición sin token');
    // Si no hay token, la petición continúa sin modificaciones
    return next(req);
};
